"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var I18n = require("i18n-js");
var regionsForSelectedCountryCode = function (props) {
    if (props.countries.length === 0 || !props.countryCode) {
        return [];
    }
    var selectedCountry = props.countries.find(function (country) {
        return country.countryCode === props.countryCode;
    });
    if (!selectedCountry) {
        return [];
    }
    return selectedCountry.subregions;
};
function mapPropsToRegionCode(props) {
    var _a;
    var regionNameOrCode = props.value;
    var country = props.countries.find(function (c) { return c.countryCode === props.countryCode; });
    var region = country.subregions.find(function (r) { return r.code === regionNameOrCode || r.name === regionNameOrCode; });
    return ((_a = region) === null || _a === void 0 ? void 0 : _a.code) || '';
}
var renderRegionTextInput = function (props) {
    return (React.createElement("input", { type: "text", name: props.name, value: props.value, onChange: props.onChange, required: true }));
};
var renderEmptyOption = function () {
    return (React.createElement("option", { value: "", key: "empty" }, I18n.t('discovery.onboardingAddressForm.select')));
};
var renderRegionSelect = function (props) {
    var options = regionsForSelectedCountryCode(props).map(function (region) {
        return (React.createElement("option", { value: region.code, key: region.code }, region.name));
    });
    options.unshift(renderEmptyOption());
    return (React.createElement("div", { className: "styled-dropdown" },
        React.createElement("select", { id: props.id, name: props.name, onChange: props.onChange, value: mapPropsToRegionCode(props), required: true }, options)));
};
var RegionSelect = function (props) {
    if (regionsForSelectedCountryCode(props).length === 0) {
        return renderRegionTextInput(props);
    }
    return renderRegionSelect(props);
};
RegionSelect.defaultProps = {
    name: 'region',
};
exports.default = RegionSelect;
//# sourceMappingURL=region_select.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/addresses/region_select.js
// module id = fb7b
// module chunks = 20 21